const OVERLAP_MARGIN = 40 // The negative margin applied to the sections linked to by this nav

document.addEventListener('DOMContentLoaded', () => {
  const $navLinks = $('#procurement-challenge-nav').find('a')

  if ($navLinks.length === 0) return

  const handlePositionChange = () => {
    const fromTop = window.scrollY
    let selectedLinkIndex = 0

    $navLinks.each(function (i, link) {
      const offsets = getOffsets(link)
      if (fromTop >= offsets.top && fromTop < offsets.bottom) {
        selectedLinkIndex = i
      }
    })

    $navLinks.each(function (i, link) {
      link.classList.toggle('selected', i === selectedLinkIndex)
    })
  }

  const getOffsets = (link) => {
    const anchor = $(link).attr('href')
    const $linkedSection = $(anchor)

    if ($linkedSection.length === 0) return { top: 0, bottom: 0 }

    const offsetTop = $linkedSection.offset().top

    return {
      top: offsetTop - OVERLAP_MARGIN,
      bottom: offsetTop + $linkedSection.outerHeight() - OVERLAP_MARGIN
    }
  }

  handlePositionChange()
  $(window).on('scroll', handlePositionChange)
})
